

<template>
    <HeaderContent title="Maintenance"/>
    <ActionContent :cta="false" ctaText="Room Maintenance" @action="modal = !modal" :filterDate="false" @showFilter="modalFilter = !modalFilter"/>
    <MaintenanceStatistics title="Maintenance Statistics" :data="statistics" />
    <MaintenanceForm :modal="modal" @update:modal="modal = $event"/>
    <MaintenanceDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>

    <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
    />

  </template>
  <script>
  
  import { ref, inject, onMounted } from 'vue';
  import HeaderContent from '@/components/HeaderContent.vue';
  import ActionContent from '@/components/ActionContent.vue';
  import MaintenanceForm from "./MaintenanceForm_old.vue";
  import MaintenanceStatistics from "@/components/StatisticData.vue";
  import MaintenanceDataTable from "@/components/DataTable.vue";
  import iconToday from '../../../public/icons/sun.svg';
  import iconWeek from '../../../public/icons/week.svg';
  // import getFormattedDateTime from '@/composable/getDateTimeFormatter';
  // import getFormattedDate from '@/composable/getDateTimeFormatter';

  //alternatif best case -! { getFormattedDate, getFormattedDateTime } utk panggil 2 format sekaligus
  import { getFormattedDate } from '@/composable/getDateTimeFormatter';
  import ToastResponse from "@/components/ToastResponse.vue";

  export default {
    components: {
      HeaderContent,
      ActionContent,
      MaintenanceForm,
      MaintenanceStatistics,
      MaintenanceDataTable,
      ToastResponse
    },
    setup(){
      const repositories = inject('repositories')
      const maintenanceRepository = repositories ? repositories.maintenance : null
      const modal = ref(false)

      const showModal = () => {
        modal.value = true
      }
      const data = ref([
       
      ]);
      const headers = ref([
        {
          key: 'room_category',
          label: 'Category',
          sortable: true,
          tdClass : 'text-center',
        },
        {
          key: 'room_code',
          label: 'Number',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'technician',
          label: 'Issue',
          sortable: true,
        },
        {
          key: 'startDate',
          label: 'Start Date',
          sortable: true,
        },
        {
          key: 'endDate',
          label: 'End Date',
          sortable: true,
        },
        {
          key: 'days',
          label: 'Total Day',
          sortable: true,
        },
        {
          key: 'remark',
          label: 'Remark',
          sortable: true,
        },
        {
          key: 'action',
          label: 'Action',
        }
      ])
      
      const modalResponse = ref({
        toast: false,
        text: "",
        success: false,
      });

      const customActions = ref([
        {
            label: 'Set Finish',
            variant: (item) => {
              return item.status === 'finish' ? 'secondary' : 'success'
            },
            icon: 'fas fa-check-circle',
            action: (item) => {
              update(item.uuid)
              console.log('Update action clicked for:', item);
            // Implement your Update logic here
            }
        },
        {
            label: 'Delete',
            variant: 'danger',
            icon: 'fas fa-trash',
            action: (item) => {
            console.log('Delete action clicked for:', item);
            // Implement your delete logic here
            }
        },
        
      ]);
      const statistics = ref([
        {
          label: 'Total',
          key: 'Today',
          value: 3,
          color: 'primary',
          icon: iconToday,
        },
        {
          label: 'Total',
          key: 'Week',
          value: 8,
          color: 'primary',
          icon: iconWeek,
        },
      ])
      
      const getAll = async ()=> {
        try{
          const getData = await maintenanceRepository.getAll()
          //data.value = getData.data.data

          const maintenanceList = getData.data.data;

          data.value = maintenanceList.map(item => ({
            ...item,
            startDate: getFormattedDate(item.start),
            endDate: getFormattedDate(item.end),
          }));

          console.log(getData.data.data)
        }catch(e){
          console.log(e)
        }
      }

      const update = async(uuid)=>{
        try{
          const postData = await maintenanceRepository.update(uuid)
          
          console.log(postData.data.data)

          // Tampilkan toast berdasarkan response dari backend
          // modalResponse.value = {
          //   toast: true,
          //   text: getData.data.message || 'Update berhasil',
          //   success: true,
          // }

          modalResponse.value = {
            toast: true,
            text: postData.data.message || 'Update Successfully',
            success: true,
          };

          console.log('modalResponse:', modalResponse.value);
          console.log('toast is:', modalResponse.value.toast);

        }catch(e){
          // Ambil pesan error dari response jika ada
          modalResponse.value = {
            toast: true,
            text: e.response?.data?.message || 'Update failed!',
            success: false,
          }

          console.log(e)
        }finally{
          getAll()
        }
      }
      onMounted(() => {
            getAll()
        })

      return{
        showModal,
        data,
        headers,
        modal,
        customActions,
        statistics,
        maintenanceRepository,
        repositories,
        getAll,
        update,
        modalResponse,
      }
    }
  
  
  }
  </script>
  
  
  <style>
  
  </style>